module.exports = __webpack_public_path__ + "img/invite-case04.70ce6f15.jpeg";